const StarIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <mask
        id="mask0_1249_703"
        style={{ maskType: 'alpha' }}
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse">
        <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
      </mask>
      <g mask="url(#mask0_1249_703)">
        <path
          fill="#FFAD5F"
          d="M7.625 6.4l2.8-3.625c.2-.267.438-.462.712-.587C11.412 2.062 11.7 2 12 2c.3 0 .588.063.863.188.274.124.512.32.712.587l2.8 3.625 4.25 1.425c.433.133.775.38 1.025.737.25.359.375.755.375 1.188 0 .2-.03.4-.087.6-.059.2-.155.392-.288.575l-2.75 3.9.1 4.1c.017.583-.175 1.075-.575 1.475-.4.4-.867.6-1.4.6-.033 0-.217-.025-.55-.075L12 19.675l-4.475 1.25a.949.949 0 01-.275.063c-.1.008-.192.012-.275.012-.533 0-1-.2-1.4-.6-.4-.4-.592-.892-.575-1.475l.1-4.125-2.725-3.875a1.861 1.861 0 01-.288-.575c-.058-.2-.087-.4-.087-.6 0-.417.12-.804.362-1.162.242-.359.58-.613 1.013-.763L7.625 6.4z"></path>
      </g>
    </svg>
  )
}

export default StarIcon
